import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatPaginator, MatTableDataSource } from '@angular/material';
import { TransformerManagerService } from 'src/app/services/transformerManager.service';
import { AddresolutionComponent } from '../addresolution/addresolution.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-maintainance',
  templateUrl: './maintainance.component.html',
  styleUrls: ['./maintainance.component.scss']
})
export class MaintainanceComponent implements OnInit {
  @ViewChild(MatPaginator,{static:true}) paginator!: MatPaginator;
  displayedColumns = ['sitename','transformerid','currentdatetime','engineername','actions'];
  dataSource;
  loginUserData= JSON.parse(localStorage.getItem("userData"));
  constructor(private dialog: MatDialog,private tnsmngr:TransformerManagerService) { }

  ngOnInit() {
    this.getResolutionData();
  }

  addResolution(action,data){
  const dialogConfig = new MatDialogConfig();
  dialogConfig.disableClose = false;
  dialogConfig.autoFocus = true;
  dialogConfig.width = '80%';
  if(action == 'add'){
    dialogConfig.data = [];
  } else {
    dialogConfig.data = data;
  }
    let dialogRef = this.dialog.open(AddresolutionComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      
      this.getResolutionData();
  });
  }

  getResolutionData(){
    this.tnsmngr.getResolutionData({userid:this.loginUserData.userid}).subscribe(data=>{
      console.log("slkdlas",data);
      this.dataSource = new MatTableDataSource(data['data']);
      this.dataSource.paginator = this.paginator;
    })
  }

  public doFilter = (value: string) => {
    this.dataSource.filter = value.trim().toLocaleLowerCase();
  }
  deleteData(data){
console.log("daasda",data);
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete this item? This action cannot be undone!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        this.performDelete(data);
        Swal.fire('Deleted!', 'Your item has been deleted.', 'success');
      }
    });
  }
  performDelete(data){
    this.tnsmngr.deleteMaintenancePlanningResolutionData({"id":data.maintainancePlanningID}).toPromise().then((response: any) => {
      if(response.code ==1)
      {
        this.getResolutionData(); 
      }
    });
  }
}
